module.exports = __webpack_public_path__ + "img/header.dad46e27.png";